export enum NewUserFormLabels {
	ContactId = 'contactId',
	UserTypeId = 'userTypeId',
	DashboardProfileId = 'dashboardProfileId',
	UserName = 'userName',
	IsActive = 'isActive',
	UserRoleIds = 'userRoleIds',
	UserLocaleIds = 'userLocaleIds'
}

export enum UserFilterFields {
	includeInactive = 'includeInactive',
	billingAgencyId = 'billingAgencyId',
	userTypeId = 'userTypeId',
	startDate = 'startDate',
	endDate = 'endDate',
	localeId = 'localeId'
}

export enum UserSearchResultFields {
	searchById = 'searchById',
	searchByUserName = 'searchByUserName',
	searchByContactName = 'searchByContactName',
	searchByEmail = 'searchByEmail'
}

export enum UserSpecificReportFormDataLabels {
	report = 'report'
}

export enum UserType {
	Customer = 1,
	Internal = 2,
	Supplier = 3,
	DataManagement = 4,
	NewSupplier = 6,
	NewCustomer = 7
}

export declare namespace User {
	interface DefaultUser extends Entity {
		lastLoginDate: string
	}

	interface UserList {
		id: number
		userName: string | null
		lastLoginDate: string | null
		isActive: boolean
		isAccountLocked: boolean
		userType: string | null
		email: string | null
		contact: Entity | null
	}

	interface Basic {
		id: number
		contact: Entity
		isActive: boolean
		userName: string
		userType: Entity
		dashboardProfile: Entity | null
		roles: Entity[]
		isAccountLocked: boolean
		locales: Entity[]
	}

	interface Request {
		[NewUserFormLabels.ContactId]: Key | null
		[NewUserFormLabels.UserTypeId]: Key | null
		[NewUserFormLabels.DashboardProfileId]: Key | null
		[NewUserFormLabels.UserName]: string
		[NewUserFormLabels.IsActive]: boolean
		[NewUserFormLabels.UserRoleIds]: Key[]
		[NewUserFormLabels.UserLocaleIds]: Key[]
	}

	namespace Form {
		interface Add {
			[NewUserFormLabels.DashboardProfileId]: Key | null
			[NewUserFormLabels.UserName]: string
			[NewUserFormLabels.IsActive]: boolean
			[NewUserFormLabels.UserRoleIds]: LabelValue<number>[]
			[NewUserFormLabels.ContactId]: LabelValue
			[NewUserFormLabels.UserTypeId]: LabelValue
			[NewUserFormLabels.UserLocaleIds]: LabelValue<number>[]
		}
	}

	interface SearchResult {
		[UserSearchResultFields.searchById]: Entity[]
		[UserSearchResultFields.searchByUserName]: Entity[]
		[UserSearchResultFields.searchByContactName]: Entity[]
		[UserSearchResultFields.searchByEmail]: Entity[]
	}

	interface UserLogin {
		id: number
		loginDate: string
		loginId: string | null
		statusCode: string | null
	}

	namespace SpecificReport {
		interface Basic {
			id: number
			reportId: number
			reportName: string
		}

		namespace Form {
			interface Add {
				report: number
			}

			interface Default {
				report: number | null
			}
		}
		interface Request {
			reportId: number
		}
	}

	interface UserWithRole {
		userId: number
		firstName: BasicString
		lastName: BasicString
		roleName: BasicString
	}

	namespace NewSupplier {
		namespace Request {
			interface Add {
				contactId: string
				userName: string
			}
		}
	}

	namespace NewCustomer {
		namespace Request {
			interface Add {
				contactId: string
				userName: string
			}
		}
	}
}
